<template>
  <div class="test-root-g">
    <component :is="testComponent"></component>
  </div>
</template>

<script>
export default {
  name: 'TestProxy',
  components: {
    'CameraTest': () => {
      return import('@/components/test/camera/CameraTestProxy');
    },
    'WebEtcTest': () => {
      return import('@/components/test/web-etc/WebEtcTest');
    }
  },
  data () {
    return {};
  },
  computed: {
    testComponent () {
      const path = location.pathname;
      let component = '';
      try{
        if(path.startsWith('/test/camera/')){
          component = 'CameraTest';
        }else if(path.startsWith('/test/web-etc')){
          component = 'WebEtcTest';
        }
        return component;
      }finally{
        document.title = `grm-v3-test ${component}`;
      }
    }
  },
  created () {
    console.log('# load test:', location.pathname);
  }
}
</script>
<style lang="scss">
body {
  overflow: auto;
  background-color: #fff;
  line-height: 20px;
}
.test-root-g {
  font-size: 14px;

  textarea, select {
    border: 1px solid #000;
  }
  button {
    border: 1px solid #000;
    padding: 2px 4px;
    background-color: #c8c8c8;
    box-shadow: 1px 1px #929292;
  }

  :not(.layer:first-child) {
    margin-top: 2px;
  }
  .info {
    > span {
      border: 1px solid #777;
      padding: 1px 2px 2px 2px;
    }
    span:first-child {
      background-color: #c0c0c0;
      font-weight: 500;
      //&:after {
      //  content: ':';
      //}
    }
  }
  //:not(.info:first-child) {
  //}
}
</style>